// MF-67 — Pick one of the tenant's types as selectable cards (label + description, in its colour).
import FormField from './FormField'
import ChoiceCards from './ChoiceCards'
import { useTypes } from './useLookups'

const HELP =
  'The top level: is the record good, neutral or a concern? Each category belongs to one type, and its templates and entries inherit it. Types are defined under Journal · Configuration · Types.'

const TypeChoice = ({ value, onChange, label = 'Type', help = HELP, hint, required }) => {
  const { list } = useTypes()
  const options = list.map((s) => ({ value: s.code, label: s.label, hint: s.description, color: s.color }))
  return (
    <FormField label={label} help={help} hint={hint} required={required}>
      {options.length ? (
        <ChoiceCards options={options} value={value} onChange={onChange} />
      ) : (
        <span style={{ fontSize: 13, color: 'rgb(148, 163, 184)' }}>No types yet.</span>
      )}
    </FormField>
  )
}

export default TypeChoice
